'use client';

import { useMemo } from 'react';

import useBreakpoint from '@gds/Pagination/Hooks/UseBreakpoint.hook';
import { ReviewRating } from '@gds/ReviewRating/ReviewRating';

import styles from './GuideSection.module.css';

export const GuideSectionRatingWrapper = ({ rating }: { rating: number }) => {
  const {
    breakpoints: { isDesktop, isTablet },
  } = useBreakpoint();

  const ratingSize = useMemo(() => {
    if (isDesktop) {
      return 'L';
    }
    if (isTablet) {
      return 'M';
    }
    return 'S';
  }, [isDesktop, isTablet]);

  return <ReviewRating score={rating} size={ratingSize} className={styles.rating} />;
};
